import React, { Component } from 'react';

// Catches render-time errors thrown anywhere below it in the tree. Without this,
// an uncaught render error unmounts the whole React tree and leaves the user
// with a blank/white screen and no way to recover other than reloading the app.
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // console.error is overridden by the logging service to also persist to
    // IndexedDB, so this ends up in the same exportable log as everything else.
    console.error("Unhandled render error caught by ErrorBoundary", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <p>Váratlan hiba történt az alkalmazásban.</p>
          <p>Az esetlegesen nem mentett adatok elveszhettek. Kérjük indítsa újra az appot.</p>
          <button onClick={this.handleReload}>Alkalmazás újraindítása</button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
